export default __webpack_public_path__ + "static/2-081451bcc679921d67e759d47862934d.jpg";